<app-stream-url
  [streamUrl]="url"
  [width]="width"
>
</app-stream-url>
